import { render, staticRenderFns } from "./OrderCheckoutVehicleRegistrationRenewal.vue?vue&type=template&id=596c24d9"
import script from "./OrderCheckoutVehicleRegistrationRenewal.vue?vue&type=script&lang=js"
export * from "./OrderCheckoutVehicleRegistrationRenewal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports